import { Button, Spin } from "antd";
import BanIcon from "components/Icons/BanIcon";
import { statusBadge } from "components/Table";
import CheckIcon from "components/Icons/CheckIcon";
import EditIcon from "components/Icons/EditIcon";
import BanModal from "./components/BanModal";
import ActivateModal from "./components/ActivateModal";
import EditPassengerModal from "../components/EditPassengerModal";
import usePassengerDetail from "hooks/passengers/usePassengerDetail";
import { useState } from "react";

export default function PassengerDetailPage() {
  const {
    data: { loading, data },
    handleCloseActivate,
    handleCloseBan,
    handleOpenActivate,
    handleOpenBan,
    openActivate,
    openBan,
    fetchData,
  } = usePassengerDetail();

  const [editModalVisible, setEditModalVisible] = useState(false);

  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      {loading ? (
        <div className="w-full flex items-center justify-center py-20">
          <Spin />
        </div>
      ) : (
        <div className="w-full">
          <h4 className="text-lg font-medium">User Information</h4>
          <div className="w-full mt-6 flex flex-wrap items-start">
            <div className="flex-shrink-0 mr-6">
              {data?.image ? (
                <img
                  src={data.image}
                  alt={`${data.first_name} ${data.last_name}`}
                  style={{ width: 100, height: 100, borderRadius: "50%" }}
                />
              ) : (
                <div
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                    backgroundColor: "#ccc",
                  }}
                />
              )}
            </div>
            <div className="flex-grow">
              <table className="text-sm">
                <tbody>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Full Name</td>
                    <td className="min-w-36">
                      {data?.first_name} {data?.last_name}
                    </td>
                  </tr>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Phone</td>
                    <td className="min-w-36">{data?.phone}</td>
                  </tr>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Status</td>
                    <td className="min-w-36">
                      {statusBadge(data?.is_active ?? false)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-full flex items-center justify-start gap-x-4 mt-6">
            <Button
              onClick={() => setEditModalVisible(true)}
              className="h-auto w-fit flex items-center px-6 py-2 gap-x-1"
              type="primary"
            >
              <span className="text-sm inline-block">
                <EditIcon />
              </span>
              <span>Edit</span>
            </Button>
            {data?.is_active ? (
              <Button
                onClick={handleOpenBan}
                className="h-auto w-fit flex items-center px-6 py-2 gap-x-1"
                type="primary"
                danger
              >
                <span className="text-sm inline-block">
                  <BanIcon />
                </span>
                <span>Ban</span>
              </Button>
            ) : (
              <Button
                onClick={handleOpenActivate}
                className="h-auto w-fit flex items-center px-6 py-2 gap-x-1 bg-success shadow-success shadow-sm hover:shadow-black"
                type="primary"
              >
                <span className="text-sm inline-block">
                  <CheckIcon />
                </span>
                <span>Activate</span>
              </Button>
            )}
          </div>
        </div>
      )}
      {data && (
        <>
          <ActivateModal
            passenger={data}
            handleClose={handleCloseActivate}
            open={openActivate}
          />
          <BanModal
            open={openBan}
            passenger={data}
            handleClose={handleCloseBan}
          />
          <EditPassengerModal
            user={data}
            visible={editModalVisible}
            onCancel={() => setEditModalVisible(false)}
            onSuccess={() => {
              setEditModalVisible(false);
              fetchData();
            }}
          />
        </>
      )}
    </div>
  );
}
